module.exports = {
      id: "prothomalo-trust-usage",
      viewBox: "0 0 260 65",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#prothomalo-trust",
      toString: function () {
        return this.url;
      }
    }